import Service from '@/services/modules/commissions.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }) => {
    const response = Service.get();

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const edit = async({ commit }, _module) => {
    const response = Service.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _module) => {
    const response = Service.rem(_module.id);

    return response;
};

const typesOfcommissions = async({commit}) => {
    const response = Service.get('types-of-commissions');
    response.then(function (_response) {
        commit('setTypeOfCommissions', _response);
    });
};

const setCommissions = async({commit}, commission) => {
    commit('setCommissions', commission);
};

const getByAdministrator = async({commit}, _id) => {
    const response = Service.get('commissions-by-administrator/'+_id);
    response.then((_response) => {
        _response[ (_response.length - 1) ].is_visible = true;
        commit('setCommissions', _response);
    });
}

export default {
    all,
    edit,
    get,
    rem,
    setCommissions,
    typesOfcommissions,
    getByAdministrator
};